module.exports = [{"value":"en","iso":"gb","name":"English","englishName":"English"},{"value":"kr","iso":"kr","name":"한글","englishName":"Korean"},{"value":"jp","iso":"jp","name":"日本語","englishName":"Japanese"}]


//////////////////
// WEBPACK FOOTER
// ./src/i18n/languages.json
// module id = 1093
// module chunks = 13